import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { ToastrService } from 'ngx-toastr';

import { CustomerTableService } from 'src/service/customer.service';

import { Customer } from 'src/api/models/customer';


@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  public customer : Customer = {enableLiveData: false, allowsAlarms: true, enableControl: false, mediaRequireSassToken: false, centreMapLatitude: -42.026167, centreMapLongitude: 146.7085} as Customer;

  public remoteData: Observable<any[]>;

  constructor(
    private service: CustomerTableService,
    private toasterService: ToastrService) { 
    this.remoteData = this.service.remoteData;
  }

  ngOnInit(): void {    
    this.service.get();
  }

  public removeRow(toDelete: Customer) {
    //const row = this.treeGrid.getRowByIndex(rowIndex);
    //const toDelete: Customer = row.rowData as Customer;  
    this.service.remove(toDelete)
  }

  public saveRow(customer: Customer) {
      this.service.update(customer);
  }

  public addRow() {
    // post to service then add to table
    this.service.add(this.customer);
  }
}
